import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityEntidadesProductivaState
} from './entity-entidades-productiva.state';
import { entityEntidadesProductivaAdapter } from './entity-entidades-productiva.state';
import {
  entityEntidadesProductivaLoadRequest,
  entityEntidadesProductivaLoadSuccess,
  entityEntidadesProductivaLoadFailure,
  entityEntidadesProductivaAddFailure,
  entityEntidadesProductivaAddRequest,
  entityEntidadesProductivaAddSuccess,
  entityEntidadesProductivaChangeFailure,
  entityEntidadesProductivaChangeRequest,
  entityEntidadesProductivaChangeSuccess,
  entityEntidadesProductivaDeleteFailure,
  entityEntidadesProductivaDeleteRequest,
  entityEntidadesProductivaDeleteSuccess
} from './entity-entidades-productiva.actions';
import { entityEntidadesProductivaTramiteChangeSuccess } from '../entidad-productiva-tramite/entidad-productiva-tramite.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityEntidadesProductivaLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEntidadesProductivaLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEntidadesProductivaLoadSuccess, (state, { items }) =>
    entityEntidadesProductivaAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityEntidadesProductivaAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEntidadesProductivaAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEntidadesProductivaAddSuccess, (state, { item }) =>
    entityEntidadesProductivaAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityEntidadesProductivaChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEntidadesProductivaChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEntidadesProductivaChangeSuccess, (state, { item }) => {
    return entityEntidadesProductivaAdapter.upsertOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  }
  ),
  on(entityEntidadesProductivaTramiteChangeSuccess, (state, { item }) =>
    entityEntidadesProductivaAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityEntidadesProductivaDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEntidadesProductivaDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEntidadesProductivaDeleteSuccess, (state, { item }) =>
    entityEntidadesProductivaAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function entidadesProductivaReducer(
  state: EntityEntidadesProductivaState | undefined,
  action: Action
) {
  return reducer(state, action);
}
